
import { Button } from "react-bootstrap";
import "./legals.scss";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { IoArrowBackSharp } from "react-icons/io5";
import { logoMap } from "themes/themes";
import { useDeepLink } from "hook/useDeepLink";

type LogoProps = {
  name: keyof typeof logoMap;
};

const Legals = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const theme = JSON.parse(localStorage.getItem('theme') ?? "");

    const Logo = ({ name }: LogoProps) => {
        const LogoComponent = logoMap[name];
        if (!LogoComponent) return null;

        return <LogoComponent />;
    };
    useDeepLink();

    return (
        <div className={`legals ${localStorage.getItem('subTheme') ?? 'peacock'}`}>
            <div className="legals__banner" role="banner">
                <Button variant="primary" size="sm" className="legals__banner__back_button btn_accent" onClick={() => navigate(-1)}><IoArrowBackSharp />
                    {t("legals_back_button_label")}
                </Button>
                <Link className="legals__banner__logo" to="/" aria-label={`${t("go_to_home")} ${theme.name}`}>
                    <Logo name={theme.id} />
                </Link>
            </div>
            <div className="legals__content">
                <h2>Mentions légales</h2>
                <p>La plateforme TACTILEO accessible aux enseignants et indirectement aux élèves (ci-après désigné la «
                    plateforme ») est mise à disposition du :
                    Ministère de l’éducation nationale, de l’enseignement supérieur et de la recherche
                    110, rue de Grenelle
                    75357 Paris Cedex 07
                    Téléphone : 01 55 55 10 10
                    par :
                    La société MASKOTT, au capital social de 346 559 euros, inscrite au registre du commerce et des sociétés
                    du Puy-en-Velay sous le numéro B 479875718, N° de TVA intracommunautaire FR479875718, dont le
                    siège social est situé :
                    21 avenue des Belges,
                    43000 Le Puy-en-Velay
                    Téléphone : 04 71 09 66 63
                    Adresse de courrier électronique : support.tactileo@maskott.com
                    Titulaire la plateforme TACTILEO.
                    Le prestataire assurant le stockage direct et permanent est la société MASKOTT dont le siège est situé
                    21 avenue des Belges, 43000 Le Puy-en-Velay, téléphone 04 71 09 66 63 via les services MICROSOFT
                    AZURE. Pascal Bringer, en tant que Directeur Général, en est son représentant légal.</p>
                <h2>Confidentialité</h2>
                <p>1.1. PoliƟque de confidenƟalité
                    1.1.1 IntroducƟon
                    CeƩe poliƟque a pour but de présenter les règles relaƟves à la protecƟon des données personnelles en
                    qualité de sous-traitant que MASKOTT (par le biais de TACTILEO) s’engage à respecter. Ces règles
                    viennent notamment en applicaƟon du Règlement (UE) 2016/679 du Parlement européen et du Conseil
                    du 27 avril 2016 (Règlement Général sur la ProtecƟon des Données, ci-après « RGPD ») relaƟf à la
                    protecƟon des personnes physiques à l’égard du traitement des données à caractère personnel et à la
                    libre circulaƟon de ces données, et abrogeant la direcƟve 95/46/CE.
                    Ce document est suscepƟble d’évoluer, notamment lorsque cela sera nécessaire pour répondre aux
                    obligaƟons de la législaƟon sur la protecƟon des données personnelles. Les noƟons concernant la
                    protecƟon des données personnelles uƟlisées dans ce document ont le même sens que celui donné
                    par le RGPD, notamment à l’arƟcle 4 du RGPD.
                    2
                    1.1.2 Respect des principes généraux sur la protecƟon des données personnelles
                    Dans le cadre d’un accès à la plateforme TacƟleo via le GAR, MASKOTT agit en tant que sous-traitant du
                    ministère de l'ÉducaƟon naƟonale et de la Jeunesse qui est le responsable de traitement. Vous pouvez
                    consulter les menƟons informaƟves RGPD du GAR à l’adresse suivante :
                    hƩps://gar.educaƟon.fr/menƟons-informaƟves-rgpd/
                    Dans un cadre hors GAR, le responsable du traitement varie en foncƟon des usages :
                    - en cas d'usages scolaires avec l'uƟlisateur idenƟfié, le responsable de traitement est le chef
                    d'établissement pour le second degré et le DASEN pour le premier degré ;
                    - en cas d'usages individuels, les traitements de données sont réalisés sur la base des collectes
                    réalisées via la ressource : c'est MaskoƩ en tant qu’éditeur qui est responsable de traitement.
                    Cela signifie que MASKOTT détermine les finalités et les moyens par lesquels vos données sont
                    traitées.
                    En tout état de cause, MASKOTT recommande de se rapprocher de la CNIL pour en savoir plus sur la
                    règlementaƟon relaƟve à la protecƟon des données personnelles, les droits des personnes physiques
                    et la possibilité d’introduire une réclamaƟon auprès de ceƩe autorité : hƩps://www.cnil.fr

                    1.1.3 Finalité et bases légales des traitements de données personnelles
                    Une « Donnée à caractère personnel » est une informaƟon relaƟve à une personne physique idenƟfiée
                    ou qui peut être idenƟfiée, directement ou indirectement, par référence à un numéro d'idenƟficaƟon
                    ou à un ou plusieurs éléments qui lui sont propres.
                    Afin de fournir le service souscrit, SAS MASKOTT, sous-traitant, situé au 21, avenue des Belges 43000
                    LE-PUY-EN-VELAY (France), collecte et traite les données personnelles uniquement dans les cas prévus
                    par la réglementaƟon en vigueur, et conforme au Code de l’EducaƟon, à savoir :
                    • L’exécuƟon d’un contrat que MaskoƩ a conclu avec, le MENJ et/ou ;
                    • L’existence d’un intérêt légiƟme à uƟliser vos données et/ou ;
                    • Le consentement du MENJ à l’uƟlisaƟon des données, et/ou ;
                    • Le respect d’une obligaƟon légale.
                </p>
            </div>
        </div>

    );
};

export default Legals;